import {useThemeSelector} from "../../../../hooks/theme/useThemeSelector";
import {ThemeElementType} from "../../../../hooks/theme/ThemeElementType";
import {useEffect, useState} from "react";
import DefaultIcons from "../icons/DefaultIcons";
import {Icons} from "../icons/Icons";
import VastBankIcons from "../icons/VastBankIcons";
import EmergeIcons from "../icons/EmergeIcons";
import SquareOneIcons from "../icons/SquareOneIcons";


export const useThemedIcons = () => {
    const { theme } = useThemeSelector()
    const [icons, setIcons] = useState<Icons>(DefaultIcons)

    useEffect(() => {
        if (theme) {
            switch (theme.toUpperCase()) {
                case ThemeElementType.VASTBANK:
                    setIcons(VastBankIcons)
                    break
                case ThemeElementType.EMERGE:
                    setIcons(EmergeIcons)
                    break
                case ThemeElementType.SQUAREONE:
                    setIcons(SquareOneIcons)
                    break
                default:
                    setIcons(DefaultIcons)
            }
        }
    }, [theme]);



    return {
        icons
    }
}